/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-grid': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 2.5H3.75c-.69 0-1.25.56-1.25 1.25V7.5c0 .69.56 1.25 1.25 1.25H7.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25zm0 5H3.75V3.75H7.5V7.5zm8.75-5H12.5c-.69 0-1.25.56-1.25 1.25V7.5c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25zm0 5H12.5V3.75h3.75V7.5zM7.5 11.25H3.75c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25H7.5c.69 0 1.25-.56 1.25-1.25V12.5c0-.69-.56-1.25-1.25-1.25zm0 5H3.75V12.5H7.5v3.75zm8.75-5H12.5c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25V12.5c0-.69-.56-1.25-1.25-1.25zm0 5H12.5V12.5h3.75v3.75z"/>'
  }
})
